import React from 'react';

const MarkdownViewer = ({ text, className = '' }) => {
    if (!text) return null;

    // Converte o texto simples em blocos (parágrafos ou listas)
    const blocks = text.split('\n\n');

    return (
        <div className={`markdown-viewer ${className}`}>
            {blocks.map((block, blockIdx) => {
                const lines = block.split('\n');
                const isLast = blockIdx === blocks.length - 1;

                // Se o bloco parece uma lista numerada (linhas começam com números) ou pontuada
                const isList = lines.every(line => /^\d+\.\s/.test(line.trim()) || /^[*-]\s/.test(line.trim()));

                if (isList) {
                    return (
                        <ul key={blockIdx} className={`ps-3 ${isLast ? 'mb-0' : 'mb-2'}`} style={{ opacity: 0.9 }}>
                            {lines.map((line, lineIdx) => {
                                const cleanLine = line.replace(/^\d+\.\s|^[*-]\s/, '');
                                return (
                                    <li key={lineIdx} className={lineIdx === lines.length - 1 ? "mb-0" : "mb-1"} dangerouslySetInnerHTML={{ __html: parseInline(cleanLine) }} />
                                );
                            })}
                        </ul>
                    );
                }

                return (
                    <p key={blockIdx} className={isLast ? 'mb-0' : 'mb-2'}>
                        {lines.map((line, lineIdx) => (
                            <React.Fragment key={lineIdx}>
                                <span dangerouslySetInnerHTML={{ __html: parseInline(line) }} />
                                {lineIdx < lines.length - 1 && <br />}
                            </React.Fragment>
                        ))}
                    </p>
                );
            })}
        </div>
    );
};

// Converte **bold** e *italic* para HTML
const parseInline = (str) => {
    let parsed = str;
    // Bold: **text**
    parsed = parsed.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    // Italic: *text* (mas que não seja **)
    parsed = parsed.replace(/(?<!\w)\*([^*]+)\*(?!\w)/g, '<em>$1</em>');
    return parsed;
};

export default MarkdownViewer;
